









































import { CollectionType } from '@/services/states/collection-state';
import { capitalize, range } from 'lodash';
import { render } from 'slimdown-js';
import { Component, Vue } from 'vue-property-decorator';
import { ContentCategory, IContent } from '../models';
import { CollectionNames, CollectionNamesArr } from '../services/meiosis';
import KanbanList from './kanban-list.vue';
import { htmlTemplate, cssTable } from '../assets/html-styles';

@Component({
  components: { KanbanList },
})
export default class KanbanLists extends Vue {
  public verticalDirection!: boolean;
  private rows: Array<CollectionNames> = [];
  private tab = 0;
  private categories: { [key in ContentCategory]: Array<CollectionNames> } = {} as {
    [key in ContentCategory]: Array<CollectionNames>;
  };
  private categoryNames: ContentCategory[] = [];

  constructor() {
    super();
  }

  private getCategoryRows(cat: ContentCategory) {
    const category = this.categories[cat];
    return this.rows
      .filter(r => category.includes(r))
      .sort((a, b) => {
        const aIdx = category.indexOf(a);
        const bIdx = category.indexOf(b);
        return aIdx > bIdx ? 1 : -1;
      });
  }

  private copyToClipboard() {
    const category = this.categories[this.categoryNames[this.tab]];
    const state = this.$store.states();
    const scenario = state.scenarios.current;
    const narratives = scenario && scenario.narratives && scenario.narratives.filter(n => n.included);
    const includedComponents = category.reduce((acc, cur) => {
      acc[cur] = narratives ? narratives.map(n => n.components[cur]) : [];
      return acc;
    }, {} as { [key: string]: string[] });
    const included = (collectionName: string, item: Partial<IContent>) =>
      includedComponents[collectionName].indexOf(item.id || '') >= 0 ? `**${item.name}**` : item.name;

    const headers = `|${category.map(c => capitalize(this.$tc(`COMP.${c.toLocaleUpperCase()}`, 2) || c)).join('|')}|`;
    const format = `|${category.map(_ => ':-----:').join('|')}|`;
    const maxRows = category.reduce((acc, cur) => {
      const ct = state[cur] as CollectionType<IContent>;
      return ct && ct.list ? Math.max(acc, ct.list.length) : acc;
    }, 0);
    const content = range(maxRows)
      .map(
        index =>
          `|${category
            .map(c => {
              const ct = state[c] as CollectionType<IContent>;
              // return ct && ct.list && ct.list.length > index ? ct.list[index].name : ' ';
              return ct && ct.list && ct.list.length > index ? included(c, ct.list[index]) : '';
            })
            .join('|')}|`
      )
      .join('\n');

    const md = `
${headers}
${format}
${content}`;
    const html = render(md);

    function listener(e: ClipboardEvent) {
      if (!e.clipboardData) return;
      e.clipboardData.setData('text/html', htmlTemplate({ body: html, css: cssTable }));
      e.clipboardData.setData('text/plain', md);
      e.preventDefault();
    }
    document.addEventListener('copy', listener);
    document.execCommand('copy');
    document.removeEventListener('copy', listener);
  }

  private async init() {
    this.$store.states.map(s => {
      this.verticalDirection = s.app.kanbanDirVert;
      this.rows.length = 0;
      CollectionNamesArr.forEach(n => {
        this.rows.push(n);
      });
      this.categories =
        s.scenarios.current && s.scenarios.current.categories
          ? s.scenarios.current.categories
          : ({} as { [key in ContentCategory]: Array<CollectionNames> });
      this.categoryNames = Object.keys(this.categories || []) as ContentCategory[];
    });
  }

  private getCardPayload(id: string) {
    console.log(`getCardPayload ${id}`);
    return id;
  }

  async mounted(): Promise<void> {
    console.log(`KanbanLists mounted`);
    await this.init();
  }
}
